/**
 * Copyright 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { ResourceUpdateStatus } from "~/generated/graphql";
import { ROUTES } from "~/routing/routes";
import { getUpdateReportStatusDisplay, NA_LABEL } from "./const";
import { type UpdateReportOverviewData } from "./types";

export const isNaLike = (value?: string | null) => {
  const trimmed = value?.trim();
  return !trimmed || trimmed.toUpperCase() === NA_LABEL.toUpperCase();
};

export const getUpdateReportStatusChartItems = (
  data: UpdateReportOverviewData | null
) => {
  if (!data) {
    return [];
  }

  return data.summary.byStatus.map(({ status, count }) => {
    const { label, color } = getUpdateReportStatusDisplay(status);
    return { label, color, count };
  });
};

export function buildResourceUpdateStatusLink({
  resourceId,
  eventId,
  eventActionId,
  status,
  includeReportView = true,
}: {
  resourceId: string;
  eventId: string;
  eventActionId?: string | null;
  status?: ResourceUpdateStatus;
  includeReportView?: boolean;
}): string {
  const baseUrl = ROUTES.events.generateDetails(eventId);
  const searchParam = `searchPhrase=${resourceId}`;
  const enableReportView =
    includeReportView &&
    status !== ResourceUpdateStatus.InProgress &&
    status !== ResourceUpdateStatus.NoUpdatesData;

  const hashParts = [
    eventActionId ? `action=${eventActionId}` : null,
    enableReportView ? "reportView=true" : null,
  ].filter(Boolean) as string[];

  const hash = hashParts.length ? `#${hashParts.join("&")}` : "";

  return `${baseUrl}?${searchParam}${hash}`;
}
